import { useMaybeFileboy, API_URL } from "@cd2/fileboy-react"
import { joinUrl } from "../utils/joinUrl"

interface IVideoData {
  transcripts: { id: string; language: string }[]
}

export function useFileboyVideo(apiUrl?: string) {
  const fileboy = useMaybeFileboy()
  const resolvedApiUrl = apiUrl || fileboy?.apiUrl || API_URL

  return {
    dataUrl(videoId: string) {
      return joinUrl(resolvedApiUrl, "videos", videoId, "data")
    },
    manifestUrl(videoId: string, opts: { type?: "dash" | "hls" | "auto" } = {}) {
      let url = joinUrl(resolvedApiUrl, "videos", videoId, "manifest")

      if (opts.type) {
        url += `?type=${opts.type}`
      }

      return url
    },
    manifestUrlHLS(videoId: string) {
      return joinUrl(resolvedApiUrl, "videos", videoId, "hls-manifest")
    },
    transcriptUrl(videoId: string, captionId: string) {
      return joinUrl(resolvedApiUrl, "videos", videoId, "transcripts", captionId)
    },
    async loadData(videoId: string): Promise<IVideoData> {
      const url = this.dataUrl(videoId)

      const response = await fetch(url)
      const json = await response.json()

      if (json.error) {
        throw json.error
      } else {
        return json.data
      }
    },
  }
}
